import { IoClose } from "react-icons/io5";
import styled from "styled-components";

export const ContactMeContainer = styled.div`
    display: block;
    position: fixed;
    z-index: 5000;
    left: 0px;
    top: 0px;
    width: 100%;
    min-height: -webkit-fill-available;
    overflow: auto scroll;
    background-color: rgba(0, 0, 0, 0.8);
    max-height: 100vh !important;
    p {
    margin-bottom: 0px;
    }
`;

export const ContactMeContent = styled.div`
    width: 90%;
    text-align: center;
    margin-left: auto; 
    margin-right: auto;
    padding: 50px;
    background-color: rgb(246, 246, 246);
    border: 1px solid rgb(136, 136, 136);
    border-radius: 8px;
    margin-top: 100px;
    @media (min-width: 1024px) { 
        width: 38%;
    }
`;

export const ContactMeHeadline = styled.h1`
    font-size: 2rem;
`;

export const ContactMeSubtitle = styled.p`
    font-size: 18px;
    margin-top: 18px;
`;

export const Close = styled.div`
    display: flex;
    justify-content: end;
    padding: 16px;
`;

export const CloseButton = styled.button`
    display: flex;
    float: right;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    cursor: pointer;
`;

export const CloseIcon = styled(IoClose)`
    color: #ffffff;
    width: 35px;
    height: 35px;
    cursor: pointer;
`;

export const ModalInputContainer = styled.div`
    margin-top: 32px;
    margin-bottom: 24px;
`;

export const ModalInput = styled.input`
    padding: 20px 16px;
    border-radius: 8px;
    display: block;
    margin-top: 8px;
    width: 100%;
    border: 1px solid var(--color-grey-100);
    background-color: #fff;
    margin-top: 10px;
    font-size: 16px;
    color: var(--color-coal);
    &:focus-visible {
        outline: 2px solid var(--color-coal);
    }
`;

export const ErrorMessage = styled.p`
    color: var(--color-alert-color);
    text-align: left;
`;

export const Button = styled.a<{ active?: boolean | undefined }>`
    background-color: ${({ active }) => (!active ? "#cccccc" : "var(--color-orange)")} ;
    color:  var(--color-white);
    font-size: 18px;
    font-weight: var(--font-weight-bold);
    border-radius: 35px;
    padding: 16px 44px;
    text-decoration: none;
    display: block;
    text-align: center;
    disabled: ${({ active }) => (!active ? "true" : "false")};
    pointer-events: ${({ active }) => (!active ? "none" : "auto")};
`;

export const Back = styled.p`
    color: rgb(0, 142, 159);
    text-decoration: underline;
    margin-bottom: 0px;
    text-align: center;
    margin-top: 20px;
    font-size: 18px;
    cursor: pointer;
`;